<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="500"
  >
    <v-card>
      <v-card-title primary-title>
        Add a document to {{ title }}
      </v-card-title>
      <v-card-text>
        <p class="text-overline">
          Document related to this party's <span class="text-weight-bold">{{ title }}</span> card
        </p>
        <v-row>
          <v-col>
            <v-file-input
              v-model="document.document"
              label="Document Select"
              filled
              accept="image/*,.pdf"
              prepend-icon="mdi-attachment"
              @change="onFileChange"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-autocomplete
              v-model="document.document_type"
              :items="documentTypes"
              label="Document Type*"
              outlined
              :error-messages="getErrorMessages($v.document.document_type)"
              @input="$v.document.document_type.$touch()"
              @blur="$v.document.document_type.$touch()"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              v-model="document.notes"
              label="Notes"
              rows="4"
              outlined
              :error-messages="getErrorMessages($v.document.notes)"
              @input="$v.document.notes.$touch()"
              @blur="$v.document.notes.$touch()"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary"
          text
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          text
          :disabled="$v.document.$invalid"
          @click="onFileUpload"
        >
          Upload
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { helpers, required } from '@vuelidate/validators'
import { mapActions } from 'vuex'
import useVuelidate from '@vuelidate/core'

import { PARTY_NAMESPACE } from '@/store/party'
import { alertHandler } from '@/alertHandler'

export default {
  name: 'PEPartyAddDocumentDialog',

  props: {
    documentTypes: {
      type: Array,
      required: true,
    },

    identifier: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    value: {
      type: Boolean,
      required: true,
    },
  },

  setup () {
    return {
      $v: useVuelidate(),
      ...alertHandler(),
    }
  },

  data () {
    return {
      document: {
        document: null,
        document_type: '',
        notes: '',
      },
    }
  },

  validations () {
    return {
      document: {
        document: {
          required: helpers.withMessage('Document is required', required),
        },

        document_type: {
          required: helpers.withMessage('Document type is required', required),
        },

        notes: {},
      },
    }
  },

  computed: {
    dialog: {
      get () { return this.value },

      set (val) {
        this.$emit('input', val)
      },
    },
  },

  watch: {
    value: {
      handler (val) {
        if (val) {
          this.document.document = null
          this.document.document_type = ''
          this.document.notes = ''
        }
      },

      immediate: true,
    },
  },

  methods: {
    getErrorMessages (validator) { return validator?.$errors.map(e => e.$message) },

    onFileChange () {
      this.$v.document.document.$touch()
    },

    onFileUpload () {
      this.document.identifier = this.identifier
      this.peUploadPartyDocument(this.document).
        then(_ => {
          this.displayAlert('success', 'Document Uploaded Successfully')
          this.dialog = false
        })
    },

    ...mapActions(PARTY_NAMESPACE, [
      'peUploadPartyDocument',
    ]),
  },
}
</script>
